import React from "react"
import Signup from "./Signup"
import { AuthProvider } from "../contexts/AuthContext"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Dashboard from "./Dashboard"
import Login from "./Login"
import PrivateRoute from "./PrivateRoute"
import ForgotPassword from "./ForgotPassword"
import UpdateProfile from "./UpdateProfile"
import Insights from './routes/Insights'
import Profile from './routes/Profile'
import Home from './home/Home'

function App() {
  return (
    <div>
      <div>
        <Router>
          {/* <AuthProvider> */}
            <Switch>
              <PrivateRoute exact path="/" component={Dashboard} />
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
              <PrivateRoute path="/update-profile" component={UpdateProfile} />
              {/* <Route path="/signup" component={Signup} /> */}
              <Route path="/login" component={Login} />
              {/* <Route path="/forgot-password" component={ForgotPassword} /> */}
              <Route path="/insights" component={Insights} />
              <Route path="/profile" component={Profile} />
              {/* <Route exact path="/" component={Home} /> */}
            </Switch>
          {/* </AuthProvider> */}
        </Router>
      </div>
    </div>
  )
}

export default App
